import { User } from '@apis/index'
import { Actions, store } from '@store/index'
import { Helper } from '@utils/index'
import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { Navigate, Outlet, useNavigate } from 'react-router-dom'

interface IProtectedRoute {
  allowedRoles: string[]
  Component: any
}
const ProtectedRoute = ({ allowedRoles, Component }: IProtectedRoute) => {
  const [loading, setLoading] = useState(true)
  const navigate = useNavigate()
  const { data: user } = useSelector((state: any) => state.user)
  useEffect(() => {
    const fetchUser = async () => {
      const localStorageUser = await Helper.getUser()
      store.dispatch(Actions.set('user', localStorageUser))
      if (!!localStorageUser?.id && localStorageUser?.role === 'user') {
        await User.find('set', 'user', localStorageUser?.id)
          .then(() => {})
          .catch((error) => {
            if (!!error) {
              navigate('/')
              Helper.removeUser()
            }
          })
      }
      setLoading(false)
    }
    fetchUser()
  }, [])

  if (loading) {
    return <></>
  }

  if (user?.role && allowedRoles.includes(user.role)) {
    return (
      <Component>
        <Outlet />
      </Component>
    )
  } else if (allowedRoles.includes('admin')) {
    return <Navigate to="/admin-login" replace />
  } else {
    return <Navigate to="/" replace />
  }
}

export default ProtectedRoute
